import DateDisplay from "components/datetime/DateDisplay";

const PrevIncidences = ({item, showPreview, ChoicesReason, ChoicesStatus}) => {

    if (!item || Object.keys(item).length === 0) return null;

    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`} style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{width: "300px"}}>
                        <div className="preview-header">
                            <div className="preview-title">
                                <label>Incidencia #{item.id}</label>
                                <div className="preview-subtitle">{item.name}</div>
                            </div>
                        </div>

                        <div className="preview-item">
                            <label>Descripción</label>
                            <div className="preview-input">{item.description || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Razón</label>
                            <div className="preview-input">{ChoicesReason[item.reason] || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Estado</label>
                            <div className="preview-input">{ChoicesStatus[item.status] || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Creado por</label>
                            <div className="preview-input">{item.created_by__email || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Creado</label>
                            <div className="preview-input">{item.created_at ? <DateDisplay date={item.created_at} format="DD-MM-YYYY HH:mm" title={false} /> : '-'}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevIncidences;
